module.exports = __webpack_public_path__ + "img/clock.d8c43333.svg";